export const splitRangeValue = (value?: string) => value?.split?.(':') ?? [];
